import { RouteSegments } from '../routingClientAdmin.interface';

export const withOptionalDetailsId = (segment: string) => {
  return `${segment}/${RouteSegments.DetailsId}?`;
};
